<template>
    <div id="app" class="fillcontain">
        <router-view v-if="isRouterAlive"></router-view>
        
    </div>
</template>

<script>
import {parseTime} from "./utils";
import {mapGetters} from "vuex";

export default {
    name: 'App',
    provide() {
        return {
            reload: this.reload,
        }
    },
    data() {
        return {
            isRouterAlive: true,
        }
    },
  computed:{
      ...mapGetters(['user','token'])
  },
  created() {
      // this.getSessionId()
        if(this.token || this.$route.query.token){
          this.$store.dispatch('GetInfo',this.token || this.$route.query.token)
          // analytics.identify(this.user.id||'');
        }
        this.getUserCurrentMsg()
  },
  methods: {
      // getSessionId(){
      //   // console.log(121)
      //   buryingPoint({session_id: '',event_id:'',prop:{}}).then(res=>{
      //     sessionStorage.setItem('session_id',res.data)
      //     this.$store.dispatch('setSessionId',res.data)
      //     this.getUserCurrentMsg(res.data)
      //   })
      // },
      getBrowserName(){
        var userAgent = navigator.userAgent;
        var browserName;

        if (userAgent.indexOf("Chrome") != -1) {
          browserName = "Google Chrome";
        } else if (userAgent.indexOf("Firefox") != -1) {
          browserName = "Mozilla Firefox";
        } else if (userAgent.indexOf("Safari") != -1) {
          browserName = "Apple Safari";
        } else if (userAgent.indexOf("Opera") != -1 || userAgent.indexOf("OPR") != -1) {
          browserName = "Opera";
        } else if (userAgent.indexOf("Edge") != -1) {
          browserName = "Microsoft Edge";
        } else if (userAgent.indexOf("Trident") != -1) {
          browserName = "Internet Explorer";
        } else {
          browserName = "Unknown Browser";
        }
        return browserName
      },
      getOperatingSystem() {
        var platform = navigator.platform;
        var userAgent = navigator.userAgent;

        var operatingSystem = "Unknown";

        if (platform.startsWith("Win")) {
          operatingSystem = "Windows";
        } else if (platform.startsWith("Mac")) {
          operatingSystem = "MacOS";
        } else if (platform.startsWith("Linux")) {
          operatingSystem = "Linux";
        } else if (/Android/.test(userAgent)) {
          operatingSystem = "Android";
        } else if (/iPhone|iPad|iPod/.test(userAgent)) {
          operatingSystem = "iOS";
        }

        return operatingSystem;
      },
        reload() {
            this.isRouterAlive = false
            this.$nextTick(function () {
                this.isRouterAlive = true
            })
        },
    },
}
</script>



// WEBPACK FOOTER //
// src/App.vue